<template>
  <BaseDialog 
    :showDialog="getShowAzPersonsAssignTemplatesDialog"
    :headline="'lang_GENERIC_CAPTION_ASSIGN_MAPPINGS'"
    :close="closeAssignTemplatesDialog"
    :alvqa="alvqa + '-assign-templates-dialog'"
    maxDialogWidth="700"
    maxCardHeight="auto"
  >
    <template v-slot:dialogText>
      <v-container fluid>
        <v-row>
          <v-col>
            <BaseEditPageDropdown 
              :context="'AzPersonsAssignTemplates'"
              field="PublishingSummaryMapping"
              :items="publishingStatementsMappings"
              :label="$t('lang_GENERIC_AZ_CAPTION_PUBLISHING_SUMMARY_MAPPING')"
              :resetValNull="true"
              :alvqa="alvqa + '-assign-templates-dropdown-publishing-summary'"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <BaseEditPageDropdown 
              :context="'AzPersonsAssignTemplates'"
              field="PublishingDetailsMapping"
              :items="publishingStatementsMappings"
              :label="$t('lang_GENERIC_AZ_CAPTION_PUBLISHING_DETAILS_MAPPING')"
              :resetValNull="true"
              :alvqa="alvqa + '-assign-templates-dropdown-publishing-details'"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <BaseEditPageDropdown 
              :context="'AzPersonsAssignTemplates'"
              field="PublishingPerWorkMapping"
              :items="publishingStatementsMappings"
              :label="$t('lang_GENERIC_AZ_CAPTION_PUBLISHING_PER_WORK_MAPPING')"
              :resetValNull="true"
              :alvqa="alvqa + '-assign-templates-dropdown-publishing-per-work'"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <BaseEditPageDropdown 
              :context="'AzPersonsAssignTemplates'"
              field="PublishingProjectsSheetsMapping"
              :items="publishingStatementsMappings"
              :label="$t('lang_GENERIC_AZ_CAPTION_PUBLISHING_PROJECTS_SHEETS_MAPPING')"
              :resetValNull="true"
              :alvqa="alvqa + '-assign-templates-dropdown-publishing-projects-sheets'"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <BaseEditPageDropdown 
              :context="'AzPersonsAssignTemplates'"
              field="PublishingTop10Mapping"
              :items="publishingStatementsMappings"
              :label="$t('lang_GENERIC_AZ_CAPTION_PUBLISHING_TOP_10_MAPPING')"
              :resetValNull="true"
              :alvqa="alvqa + '-assign-templates-dropdown-publishing-top-10-works'"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-checkbox
              v-model="assignClearEmpty"
              :label="$t('lang_GENERIC_CAPTION_ASSIGN_MAPPINGS_CLEAR_ON_EMPTY')"
              :alvqa="alvqa + '-assign-templates-checkbox-clear-on-empty'"
            />
          </v-col>
        </v-row>
      </v-container>
    </template>
    <template v-slot:dialogActions>
      <v-container fluid>
        <v-row>
          <v-spacer />
          <v-col class="text-right">
            <span v-if="assignResultLink">
              <span :alvqa="alvqa + '-text-download-file'">{{ $t('lang_GENERIC_CAPTION_CLICK_HERE_TO_DOWNLOAD') }}</span>
              <span class="pr-4">
                <BaseIcon
                  @click.stop="downloadAssignResult"
                  icon="cloud_download"
                  :tooltipText="$t('lang_GENERAL_CAPTION_ICON_DOWNLOAD')"
                  :alvqa="alvqa + '-icon-download-file'"
                />
              </span>
            </span>
            <span>
              <BaseButton 
                label="lang_GENERIC_CAPTION_ASSIGN"
                color="buttonStandard"
                @click="assignTemplatesUiOnly"
                :disabled="!canAssign"
                :alvqa="alvqa + '-assign-templates-button-assign'"
              />
            </span>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </BaseDialog>
</template>

<script>
import { mapGetters } from 'vuex'

import BaseDialog from '@/components/_base/BaseDialog'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseIcon from '@/components/_buttons/BaseIcon'

export default {
  name: 'AzPersonsAssignTemplatesDialog',
  components: { BaseDialog, BaseEditPageDropdown, BaseButton, BaseIcon },
  props: {
    alvqa: { type: String, default: 'az-persons' }
  },
  data() {
    return {
      publishingStatementsMappings: [],
      assignClearEmpty: false,
    }
  },
  computed: {
    ...mapGetters(['getShowAzPersonsAssignTemplatesDialog','getAzPersonsAssignMappingsResultLink']),
    canAssign() {
      if (this.assignClearEmpty === true) return true
      const s = this.$store.getters.getAzPersonsAssignTemplatesDetailsPublishingSummaryMapping
      const d = this.$store.getters.getAzPersonsAssignTemplatesDetailsPublishingDetailsMapping
      const p = this.$store.getters.getAzPersonsAssignTemplatesDetailsPublishingPerWorkMapping
      const proj = this.$store.getters.getAzPersonsAssignTemplatesDetailsPublishingProjectsSheetsMapping
      const top10 = this.$store.getters.getAzPersonsAssignTemplatesDetailsPublishingTop10Mapping
      return (s !== null && s !== undefined) || (d !== null && d !== undefined) || (p !== null && p !== undefined) || (proj !== null && proj !== undefined) || (top10 !== null && top10 !== undefined)
    },
    assignResultLink() {
      return this.getAzPersonsAssignMappingsResultLink || this.$store.getters.getAzGroupsAssignMappingsResultLink
    },
  },
  methods: {
    async getPublishingStatementMappingsForDialog() {
      let currentDomain = this.$store.getters.getSelectedMappingsDomainsFilter
      let currentDirection = this.$store.getters.getSelectedMappingsDirectionsFilter
      let previousMappings = this.$store.getters.getMappings.slice()

      this.$store.commit('setSelectedMappingsDomainsFilter', 'publishing_statements')
      this.$store.commit('setSelectedMappingsDirectionsFilter', 'export')
      await this.$store.dispatch('fetchMappingsByDomain')

      let mappingsList = this.$store.getters.getMappings
      this.publishingStatementsMappings = []
      mappingsList.forEach((v) => {
        if (v.direction !== 'export') return
        this.publishingStatementsMappings.push({
          value: v.alvId,
          text: v.abbreviation,
          alvqa: this.alvqa + `-assign-templates-export-mapping-${v.alvId}`
        })
      })

      this.$store.commit('setSelectedMappingsDomainsFilter', currentDomain)
      this.$store.commit('setSelectedMappingsDirectionsFilter', currentDirection)
      // Restore prior list locally — avoid second fetchMappingsByDomain
      if (currentDomain) {
        this.$store.commit('setMappings', previousMappings)
      }
    },
    closeAssignTemplatesDialog() {
      this.$store.commit('setShowAzPersonsAssignTemplatesDialog', false)
      this.$store.commit('setAzPersonsAssignMappingsResultLink', null)
      this.$store.commit('setAzGroupsAssignMappingsResultLink', null)
      this.$store.commit('setPublishingStatementsGroupIdsForMapping', [])
    },
    async assignTemplatesUiOnly() {
      const groupIds = this.$store.getters.getPublishingStatementsGroupIdsForMapping
      const hasGroups = groupIds && groupIds.length > 0
      const selectedPersons = this.$store.getters.getSelectedAzPersons

      if (selectedPersons.length > 0 || !hasGroups) {
        await this.$store.dispatch('assignMappingsAzPersons', { clearEmpty: this.assignClearEmpty })
      }

      if (hasGroups) {
        this.$store.commit('setAzGroupsAssignTemplatesDetailsPublishingSummaryMapping',
            this.$store.getters.getAzPersonsAssignTemplatesDetailsPublishingSummaryMapping)
        this.$store.commit('setAzGroupsAssignTemplatesDetailsPublishingDetailsMapping',
            this.$store.getters.getAzPersonsAssignTemplatesDetailsPublishingDetailsMapping)
        this.$store.commit('setAzGroupsAssignTemplatesDetailsPublishingPerWorkMapping',
            this.$store.getters.getAzPersonsAssignTemplatesDetailsPublishingPerWorkMapping)
        this.$store.commit('setAzGroupsAssignTemplatesDetailsPublishingProjectsSheetsMapping',
            this.$store.getters.getAzPersonsAssignTemplatesDetailsPublishingProjectsSheetsMapping)
        this.$store.commit('setAzGroupsAssignTemplatesDetailsPublishingTop10Mapping',
            this.$store.getters.getAzPersonsAssignTemplatesDetailsPublishingTop10Mapping)
        this.$store.commit('setSelectedAzGroups', groupIds)
        this.$store.commit('setAssignAllAzGroups', false)
        await this.$store.dispatch('assignMappingsAzGroups', { clearEmpty: this.assignClearEmpty })
        this.$store.commit('setPublishingStatementsGroupIdsForMapping', [])
      }
    },
    async downloadAssignResult() {
      const personsLink = this.$store.getters.getAzPersonsAssignMappingsResultLink
      const groupsLink = this.$store.getters.getAzGroupsAssignMappingsResultLink

      if (personsLink && groupsLink) {
        try {
          const [personsRes, groupsRes] = await Promise.all([fetch(personsLink), fetch(groupsLink)])
          const personsCsv = await personsRes.text()
          const groupsCsv = await groupsRes.text()
          const groupsLines = groupsCsv.split('\n')
          groupsLines.shift()
          const merged = personsCsv.trimEnd() + '\n' + groupsLines.filter(l => l.trim()).join('\n') + '\n'
          const blob = new Blob([merged], { type: 'text/csv;charset=utf-8;' })
          const url = URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = url
          a.download = 'az_assign_mappings_' + Date.now() + '.csv'
          a.click()
          URL.revokeObjectURL(url)
        } catch (e) {
          window.open(personsLink, '_blank')
        }
      } else {
        const link = personsLink || groupsLink
        if (link) window.open(link, '_blank')
      }
    },
  },
  watch: {
    getShowAzPersonsAssignTemplatesDialog: function (newVal, oldVal) {
      if (newVal === true) {
        this.getPublishingStatementMappingsForDialog()
      }
    }
  }
}
</script>


